import { useMutation, useQueryClient } from "@tanstack/react-query";
import { PalletService } from "src/services/pallets";
import { queryKeys } from "src/constants";
import { PostPalletCompleteRequestBody } from "src/types/api/pallets/postPalletComplete";

const useMarkPalletComplete = (palletService: PalletService, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  const { mutateAsync: markPalletComplete, isPending: isCompleting } = useMutation({
    mutationFn: ({ palletId, body }: { palletId: string; body: PostPalletCompleteRequestBody }) =>
      palletService.completePallet(palletId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.buildingPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.completePallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.paginatedPallets() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletStats() });
      queryClient.invalidateQueries({ queryKey: queryKeys.palletLocations() });
      onSuccess?.();
    }
  });

  return { markPalletComplete, isCompleting };
};

export { useMarkPalletComplete };
